import { Modal } from "antd";
import { Formik } from "formik";
import Eye from "../../components/Eye";
import AddBotModel from "./AddBotModel";
import { useEffect, useState } from "react";
import Loader from "../../components/other/Loader";
import { pageRoutes } from "../../routes/pageRoutes";
import { pipGetTeamDirectory } from "../../utils/pip";
import { useDispatch, useSelector } from "react-redux";
import NoRecord from "../../components/other/NoRecord";
import ErrorMessage from "../../components/ErrorMessage";
import { editBasicDetailSchema } from "../../utils/schema";
import { useLocation, useNavigate } from "react-router-dom";
import LocationDropdown from "../../components/country-state-city";
import {
  fetchTeamLeaders,
  fetchBotDirectory,
} from "../../redux/action/moreAction";
import {
  CreateBot,
  fetchBotTypes,
  authUpdateMemberDetails,
  fetchWeightClassCategories,
} from "../../redux/action/authAction";

const OurLeaderShip = ({ list = [], isTeams = false }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [isEye3, setIsEye3] = useState(false);
  const [isEye4, setIsEye4] = useState(false);
  const { user, token } = pipGetTeamDirectory();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitButton, setIsSubmitButton] = useState(false);
  const [isAddBotModalOpen, setIsAddBotModalOpen] = useState(false);
  const { aboutData, botList } = useSelector((state) => state.moreReducer);

  const filteredBotList = botList?.filter(
    (item) => item?.created_by?.id == user?.id
  );

  const initialState2 = {
    name: "",
    about: "",
    email: "",
    number: "",
    password: "",
    designation: "",
    website_link: "",
    discord_name: "",
    profile_image: "",
    confirm_password: "",
    tournament: "",
  };

  const [bot_id, setBot_id] = useState(user?.bot_id ?? null);
  const [weight_class_id, setWeight_class_id] = useState(
    user?.weight_class?.id ?? null
  );

  const { weightClassCategories } = useSelector((state) => state.authReducer);
  const { isLoading1 } = useSelector((state) => state.moreReducer);

  const [selectedLocation, setSelectedLocation] = useState({
    country: user?.country ?? "",
    state: user?.state ?? "",
    city: user?.city ?? "",
  });

  const handleLocationChange = (location) => {
    setSelectedLocation(location);
  };

  useEffect(() => {
    dispatch(fetchBotTypes());
    dispatch(fetchWeightClassCategories());
  }, []);

  const handleUpdateMemberDetails = (values) => {
    const data = {
      ...values,
      user_id: user?.id,
      bot_id,
      weight_class_id,
    };

    const formdata = new FormData();

    // Append all key-value pairs from data
    Object.entries(data).forEach(([key, value]) => {
      if (key === "profile_image") {
        // Append only if profile_image is a new file, ignore if it's a URL
        if (value instanceof File) {
          formdata.append(key, value);
        }
      } else {
        formdata.append(key, value ?? ""); // Append all other fields
      }
    });

    const callback = (response) => {
      if (response.success) {
        localStorage.setItem(
          "Team-Member-Detail",
          JSON.stringify({
            token,
            user: { ...user, ...response?.data },
          })
        );
        setIsModalOpen(false);
        dispatch(fetchTeamLeaders());
      }
    };
    dispatch(authUpdateMemberDetails({ payload: formdata, callback }));
  };

  const hadnleAddBotSubmit = (formdata) => {
    const callback = (response) => {
      if (response.success) {
        setIsSubmitButton(false);

        // navigate(pageRoutes?.botDirectory);
        dispatch(fetchBotDirectory());
      } else {
        setIsSubmitButton(false);
      }
    };
    dispatch(CreateBot({ payload: formdata, callback }));
  };

  if (isLoading1) {
    return <Loader />;
  }

  const openLinksInNewTab = (html) => {
    if (!html) return "";

    return html.replace(
      /<a /g,
      '<a target="_blank" rel="noopener noreferrer" '
    );
  };
  return (
    <>
      <div class="untree_co-section pt-5 pb-5">
        {pathname == pageRoutes?.about && (
          <div class="container pb-5">
            <div class="row  ">
              <div class="col-lg-5 mx-auto text-center">
                <h2 class="section-title">
                  <strong>{aboutData?.about_title}</strong>
                </h2>
              </div>
            </div>

            <div class="row pt-4">
              <div class="ct_team_info1">
                <div
                  dangerouslySetInnerHTML={{
                    __html: `${openLinksInNewTab(aboutData?.about_content)}`,
                  }}
                />
              </div>
            </div>
          </div>
        )}
        {isTeams && <div class="container">
          <div class="row mb-5 pb-5">
            <div class="col-lg-12 mx-auto text-center">
              <div className={` `}>
                <div>
                  <h2 class="section-title mb-2">
                    <strong>Robot Combat Teams</strong>
                  </h2>

                  <p>
                    Please create a FREE account to add your robot combat team
                    to the RC101 Team Directory. Each team receives their own
                    customizable page in the directory! Once you create a team,
                    you can add your bots to the directory as well.{" "}
                  </p>
                </div>
                {token && (
                  <div className="text-end mt-5">
                    <button
                      onClick={() => setIsAddBotModalOpen(true)}
                      type="button"
                      class="btn btn-secondary ct_btn_animate ms-auto"
                    >
                      {" "}
                      + Add Bot
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div class="row pt-4">
            {list?.length > 0 ? (
              list?.map((item) => (
                <div class="col-md-6 mb-5 pb-3">
                  <div class="ct_team_card_head position-relative">
                    <div class="ct_overlay_hidden">
                      <img
                        src={item?.profile_image ?? "/images/user_profile.png"}
                        alt=""
                      />
                      {/* <img src={process.env.PUBLIC_URL + "/images/Robotic_img/person_1.jpg"} alt="" /> */}
                    </div>
                    <div class="ct_team_title">
                      <h4>{item?.name}</h4>
                      <p class="mb-0">{item?.designation}</p>
                      <div className="d-flex align-items-center gap-1 justify-content-between flex-wrap">
                        <a className="mb-0 ct_fs_16">
                          {[item?.country, item?.state, item?.city]
                            .filter(Boolean)
                            .join(", ")}
                        </a>
                        <a className="mb-0 ct_fs_16">
                          {item?.tournament ?? ""}
                        </a>
                      </div>
                    </div>

                    <div className="ct_overlay_card_btns">
                      <button
                        type="button"
                        className="ct_team_edit_icon_3"
                        onClick={() => {
                          if (user?.id == item?.id) {
                            localStorage.setItem(
                              "Team-Member-Detail",
                              JSON.stringify({
                                token,
                                user: { ...user, ...item },
                              })
                            );
                          }
                          navigate(pageRoutes?.teamDetail, {
                            state: {
                              data: {
                                token,
                                user: { ...user, ...item },
                              },
                            },
                          });
                        }}
                      >
                        <i class="fa fa-eye"></i>
                      </button>

                      {user?.id == item?.id && (
                        <>
                          <button
                            type="button"
                            className="ct_team_edit_icon_3"
                            onClick={() => {
                              localStorage.setItem(
                                "Team-Member-Detail",
                                JSON.stringify({
                                  token,
                                  user: { ...user, ...item },
                                })
                              );
                              setSelectedLocation({
                                country: item?.country,
                                state: item?.state,
                                city: item?.city,
                              });
                              setIsModalOpen(true);
                            }}
                          >
                            <i class="fa-regular fa-pen-to-square"></i>
                          </button>
                        </>
                      )}
                    </div>
                  </div>

                  <div class="ct_team_info1">
                    {!item?.about && <p></p>}
                    {item?.about && (
                      <div
                        dangerouslySetInnerHTML={{ __html: `${item?.about}` }}
                      />
                    )}
                  </div>
                </div>
              ))
            ) : (
              <NoRecord className={"text-center ct_fs_20"} />
            )}
          </div>
        </div>}
      </div>

      {/* Edit Team Detail modal S */}
      <>
        <Modal
          title={``}
          className="w-100"
          style={{ maxWidth: "800px" }}
          centered={true}
          open={isModalOpen}
          onCancel={() => {
            setIsModalOpen(false);
            navigate(pageRoutes.more?.teamDirectory);
          }}
          footer={null}
        >
          <div className="mt-4">
            <div
              class="modal-dialog modal-dialog-centered mx-0"
              style={{ maxWidth: "100%" }}
            >
              <div class="modal-content border-0">
                <div class="modal-body py-0">
                  <h4 className="ct_fs_24 text-center mb-4">
                    Edit Robot Combat Team Details
                  </h4>
                  <Formik
                    initialValues={{
                      ...initialState2,
                      profile_image: user?.profile_image,
                      name: user?.name,
                      email: user?.email,
                      number: user?.number,
                      designation: user?.designation,
                      website_link: user?.website_link,
                      discord_name: user?.discord_name,
                      about: user?.about,
                      password: user?.password,
                      confirm_password: user?.confirm_password,
                      tournament: user?.tournament,
                    }}
                    validationSchema={editBasicDetailSchema}
                    onSubmit={(values, actions) => {
                      handleUpdateMemberDetails(values);
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      setTouched,
                      handleChange,
                      handleBlur,
                      setFieldValue,
                      handleSubmit,
                    }) => (
                      <form
                        onSubmit={handleSubmit}
                        className="ct_free_account_overflow"
                        style={{ overflowX: "hidden" }}
                      >
                        {/* Upload photo input */}
                        <div className="form-group mb-3">
                          <label className="mb-2 d-block ct_fw_600">
                            Profile Image
                          </label>
                          <label for="ct_team_upload_img" className="d-block">
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(event) => {
                                const file = event.currentTarget.files[0];
                                setTouched({ profile_image: true });
                                setFieldValue("profile_image", file);
                              }}
                              onBlur={handleBlur}
                              className="form-control d-none"
                              id="ct_team_upload_img"
                            />
                            <div className="ct_team_upload_box_23">
                              <p className="text-center mb-0 ct_fs_18">
                                Upload Image here
                              </p>

                              {values?.profile_image && (
                                <img
                                  src={
                                    typeof values.profile_image === "string"
                                      ? values.profile_image
                                      : URL.createObjectURL(
                                        values.profile_image
                                      )
                                  }
                                  className="ct_uploded_img"
                                  alt="Uploaded Preview"
                                />
                              )}
                            </div>
                          </label>
                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName="profile_image"
                          />
                        </div>
                        {/* Name Input */}
                        <div className="form-group mb-3">
                          <label className="mb-2 d-block ct_fw_600">
                            Team Name <span className="ct_red_text">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Enter team name"
                            className="form-control"
                            value={values.name}
                            id="name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />

                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName="name"
                          />
                        </div>
                        {/* Email Input */}
                        <div className="form-group mb-3">
                          <label className="mb-2 d-block ct_fw_600">
                            Contact Email
                          </label>
                          <input
                            type="email"
                            placeholder="Enter contact email"
                            className="form-control"
                            value={values.email}
                            id="email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={true}
                          />

                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName="email"
                          />
                        </div>
                        {/* Number Input */}
                        <div className="form-group mb-3">
                          <label className="mb-2 d-block ct_fw_600">
                            Number
                          </label>
                          <input
                            type="text"
                            placeholder="Enter number"
                            className="form-control"
                            value={values.number}
                            id="number"
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />

                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName="number"
                          />
                        </div>
                        {/* Position Input */}
                        <div className="form-group mb-3">
                          <label className="mb-2 d-block ct_fw_600">
                            Position
                          </label>
                          <input
                            type="text"
                            placeholder="Enter your position"
                            className="form-control"
                            value={values.designation}
                            id="designation"
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />

                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName="designation"
                          />
                        </div>
                        {/* Website link */}
                        <div className="form-group mb-3">
                          <label className="mb-2 d-block ct_fw_600">
                            Website Link
                          </label>
                          <input
                            type="text"
                            placeholder="Enter Website Link"
                            className="form-control"
                            value={values.website_link}
                            id="website_link"
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName="website_link"
                          />
                        </div>
                        {/* Discord Number */}
                        <div className="form-group mb-3">
                          <label className="mb-2 d-block ct_fw_600">
                            Discord Name
                          </label>
                          <input
                            type="text"
                            placeholder="Enter discord name"
                            className="form-control"
                            value={values.discord_name}
                            id="discord_name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName="discord_name"
                          />
                        </div>
                        {/*  Bot Directory */}
                        <div className="form-group mb-3">
                          <label className="mb-2 d-block ct_fw_600">
                            Bot Directory
                          </label>
                          <select
                            className="form-control"
                            onChange={(e) => {
                              const selectedBot = filteredBotList.find(
                                (bot) => bot.id == e.target.value
                              );

                              setWeight_class_id(selectedBot?.weight_class?.id);
                              setBot_id(e.target.value);
                            }}
                            value={bot_id}
                          >
                            <option value="" disabled selected>
                              Select Bot
                            </option>
                            {filteredBotList?.map((bot) => (
                              <option key={bot.id} value={bot.id}>
                                {bot.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        {/*  Weight Classes */}
                        <div className="form-group mb-3">
                          <label className="mb-2 d-block ct_fw_600">
                            Weight Classes
                          </label>
                          <select
                            className="form-control"
                            onChange={(e) => {
                              setWeight_class_id(e.target.value);
                            }}
                            value={weight_class_id}
                          >
                            <option value="" disabled selected>
                              Select Weight Class
                            </option>
                            {weightClassCategories?.map((item) => (
                              <option key={item.id} value={item.id} disabled>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/*  Primary League You Compete In */}
                        <div className="form-group mb-3">
                          <label className="mb-2 d-block ct_fw_600">
                            Primary League You Complete In
                          </label>
                          <input
                            type="text"
                            placeholder="Enter enter primary league you complete in"
                            className="form-control"
                            value={values.tournament}
                            id="tournament"
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />

                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName="tournament"
                          />
                        </div>
                        {/* State Country City */}
                        <LocationDropdown
                          state={selectedLocation}
                          onChange={handleLocationChange}
                        />
                        {/* Password Input */}
                        <div className="form-group mb-3">
                          <label className="mb-2 d-block ct_fw_600">
                            Password
                          </label>
                          <div className="position-relative">
                            <input
                              required
                              type={!isEye3 ? "password" : "text"}
                              name="password"
                              autoComplete="off"
                              placeholder="Enter password"
                              className="form-control"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.password}
                            />
                            <Eye isEye={isEye3} onClick={setIsEye3} />
                          </div>

                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName="password"
                          />
                        </div>
                        {/* Confirm Password Input */}
                        <div className="form-group mb-3">
                          <label className="mb-2 d-block ct_fw_600">
                            Confirm Password
                          </label>
                          <div className="position-relative">
                            <input
                              required
                              type={!isEye4 ? "password" : "text"}
                              name="confirm_password"
                              placeholder="Enter confirm password"
                              autoComplete="off"
                              className="form-control"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.confirm_password}
                            />
                            <Eye isEye={isEye4} onClick={setIsEye4} />
                          </div>

                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName="confirm_password"
                          />
                        </div>
                        {/* Description Input*/}
                        <div className="form-group mb-3">
                          <label className="mb-2 d-block ct_fw_600">
                            Description
                          </label>
                          <textarea
                            className="form-control"
                            rows={4}
                            placeholder="Enter Description"
                            value={values.about}
                            id="about"
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />

                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName="about"
                          />
                        </div>
                        {/* Submit & Skip button */}
                        <div className="text-center mt-4 mx-auto d-flex align-items-center gap-2 justify-content-center">
                          <button
                            type="button"
                            onClick={handleSubmit}
                            className="btn btn-secondary ct_btn_animate"
                          >
                            {" "}
                            Submit
                          </button>
                        </div>
                      </form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </>

      {/* Add Bot Modal */}
      <AddBotModel
        user={user}
        isAddBotModalOpen={isAddBotModalOpen}
        setIsAddBotModalOpen={setIsAddBotModalOpen}
        hadnleAddBotSubmit={hadnleAddBotSubmit}
        isSubmitButton={isSubmitButton}
        setIsSubmitButton={setIsSubmitButton}
      />
    </>
  );
};

export default OurLeaderShip;
